export enum BankAccountType {
  poupanca = "Poupança",
  investimento = "Investimento",
  corrente =  "Corrente"
}
